// extracted by mini-css-extract-plugin
module.exports = {"container":"Chart_container___GtwM","card":"Chart_card__15bHk","infected":"Chart_infected__3Z8Rx","recovered":"Chart_recovered__arsEk","deaths":"Chart_deaths__2_JVz"};